var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrackOrderIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 17,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Haleon Rewards - 154",
    clipPath: "url(#clip0_2576_353)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 1569,
    transform: "translate(-56 -854)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 34"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608441"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608440"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608436",
    filter: "url(#filter0_d_2576_353)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -24,
    y: -588,
    width: 366,
    height: 774,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608360"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 2608355"
  }, /*#__PURE__*/React.createElement("g", {
    id: "box",
    clipPath: "url(#clip1_2576_353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3.3835V3.3795L12.994 4.7205L16 3.5935L8 0.593498L0 3.5935L8 6.5935L10.994 5.4705L8 4.2365V4.2335L10 3.3835Z",
    fill: "#333F48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0 4.5935V13.5935L7.5 16.4065V7.4065L0 4.5935ZM4 13.6265L2 12.8765V11.8095L4 12.5595V13.6265Z",
    fill: "#333F48"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13 5.7185V8.2235L11 8.9735V6.4685L8.5 7.4065V16.4065L16 13.5935V4.5935L13 5.7185Z",
    fill: "#333F48"
  }))))))), /*#__PURE__*/React.createElement("rect", {
    x: -23.75,
    y: -587.75,
    width: 365.5,
    height: 773.5,
    rx: 9.75,
    stroke: "#E7E7E7",
    strokeWidth: 0.5
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2576_353",
    x: -40,
    y: -603,
    width: 398,
    height: 806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2576_353"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2576_353",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2576_353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 430,
    height: 1569,
    fill: "white",
    transform: "translate(-56 -854)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2576_353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackOrderIcon);
export default __webpack_public_path__ + "static/media/trackOrderIcon.dba1411ce7129b15f73a9d5ad4a09d0d.svg";
export { ForwardRef as ReactComponent };